/**
 * Coarse-grained relative time formatter — JA. Used by the WBS
 * detail-panel Backlog auto-update badge ("3 分前"). Resolution stops
 * at days; the badge is signalling provenance, not a precise clock.
 */
export function formatRelativeFromNow(d: Date, now: Date = new Date()): string {
  const diffMs = now.getTime() - d.getTime();
  if (diffMs < 60_000) return 'たった今';
  const min = Math.floor(diffMs / 60_000);
  if (min < 60) return `${min} 分前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 時間前`;
  const day = Math.floor(hr / 24);
  return `${day} 日前`;
}
